import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function openLink(url) {
  if (!url) return;
  window.location.href = url;
}

export default function BusinessHub() {
  const navigate = useNavigate();
  const [showPetrolOptions, setShowPetrolOptions] = useState(false);

  const links = useMemo(() => {
    const origin = window.location.origin;
    return {
      petrolNew: process.env.REACT_APP_PETROL_NEW_USER_URL || `${origin}/register`,
      petrolLogin: process.env.REACT_APP_PETROL_EXISTING_LOGIN_URL || `${origin}/login`,
      carService: process.env.REACT_APP_CAR_SERVICE_URL || `${origin}/car-service`,
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-3xl">
        <div className="text-center mb-8">
          <div className="text-5xl mb-2">🏢</div>
          <h1 className="text-2xl font-bold">Select Your Business Type</h1>
          <p className="text-gray-500">Choose the business module you want to open</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button
            type="button"
            onClick={() => setShowPetrolOptions(true)}
            className="p-5 rounded-xl border-2 border-gray-200 text-left transition hover:border-orange-500 hover:shadow-lg bg-gray-50"
          >
            <div className="text-4xl mb-2">⛽</div>
            <h3 className="font-bold text-lg">Petrol Pump Management</h3>
            <p className="text-sm text-gray-500">Open petrol pump software</p>
          </button>

          <button
            type="button"
            onClick={() => navigate('/karmkand')}
            className="p-5 rounded-xl border-2 border-gray-200 text-left transition hover:border-orange-500 hover:shadow-lg bg-orange-50"
          >
            <div className="text-4xl mb-2">🕉️</div>
            <h3 className="font-bold text-lg">Karmkand Sanskar</h3>
            <p className="text-sm text-gray-500">Open Karmkand Bhaskar</p>
          </button>

          <button
            type="button"
            onClick={() => openLink(links.carService)}
            className="p-5 rounded-xl border-2 border-gray-200 text-left transition hover:border-orange-500 hover:shadow-lg bg-cyan-50"
          >
            <div className="text-4xl mb-2">🛠️</div>
            <h3 className="font-bold text-lg">Car Service</h3>
            <p className="text-sm text-gray-500">Open car service module</p>
          </button>
        </div>
      </div>

      {showPetrolOptions && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setShowPetrolOptions(false)}>
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-2">Petrol Pump Management</h2>
            <p className="text-sm text-gray-500 mb-5">Choose one option</p>

            <div className="space-y-3">
              <button
                type="button"
                onClick={() => openLink(links.petrolNew)}
                className="w-full py-3 rounded-xl font-semibold text-white bg-orange-600 hover:bg-orange-700 transition"
              >
                New User Registration
              </button>
              <button
                type="button"
                onClick={() => openLink(links.petrolLogin)}
                className="w-full py-3 rounded-xl font-semibold text-orange-700 bg-orange-100 hover:bg-orange-200 transition"
              >
                Existing User Login
              </button>
            </div>

            <button
              type="button"
              onClick={() => setShowPetrolOptions(false)}
              className="w-full mt-4 py-2.5 rounded-xl font-medium border border-gray-200 hover:bg-gray-50 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
